import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

const Config = require('../../config');

class ModalTraceability extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show:  false, 
			traceability:[],
			unit:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(unit){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'units/all_status?unit_number='+unit,{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					traceability: response.res,
					show: true,
					unit:unit
				});
			}
		})
	}

	handleClose(){
		this.setState({
			show: false,
			unit:"",
			traceability:[]
		});
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>trazabilidad de unidad</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12">
			        			<span className="span-min">No. Unidad: </span>
			        			<span>{this.state.unit}</span>
		        			</div>
		        		</div>
		        		<div className="col-xs-12 form-group">
		        			<Table resposive hover>
								<thead>
									<tr>
										<th>Componente</th>
										<th>No. Componente</th>
										<th>Volumen</th>
										<th>Estatus</th>
										<th>F. Proceso</th>
									</tr>
								</thead>
								<tbody>
									{this.state.traceability.map((t, i)=>(
										<tr key={i}>
											<td>{t.component}</td>
											<td>{t.component_number}</td>
											<td>{t.volume+' ml'}</td>
											<td>{t.status}</td>
											<td>
												{t.process_date !== null ?
													moment(t.process_date).format('DD/MM/YYYY')
												: ""}
											</td>
										</tr>
									))}
								</tbody>
							</Table>
		        		</div>
					</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')} onClick={this.handleClose}  />
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations') (ModalTraceability);
